/** @type {import('zudoku').ZudokuConfig} */
const config = {
  site: {
    title: "Project V docs",
    logo: {
      src: { light: "/PV-logo-light.svg", dark: "/PV-logo-dark.svg" },
      alt: "Project V Logo",
      width: "50px",
    },
  },
  authentication: {
    type: "auth0",
    domain: process.env.ZUDOKU_PUBLIC_AUTH0_DOMAIN,
    clientId: process.env.ZUDOKU_PUBLIC_AUTH0_CLIENT_ID,
    scopes: ["openid", "profile", "email", "custom_scope"],
  },
  protectedRoutes: [
    "/catalog/*", // Protect all catalog routes
  ],
  catalogs: {
    path: "catalog",
    label: "API Catalog",
  },
  search: {
    type: "pagefind",
    // Optional: Maximum number of sub results per page
    maxSubResults: 3,
    // Optional: Configure search result ranking (defaults shown below)
    ranking: {
      termFrequency: 0.8,
      pageLength: 0.6,
      termSimilarity: 1.2,
      termSaturation: 1.2,
    },
  },
  navigation: [
    // // Main navigation in the top bar
    // {
    //   type: "category", // Changed to category to allow nested documentation links
    //   label: "Documentation",
    //   icon: "book-open",
    //   items: [
    //     {
    //       type: "category",
    //       label: "Getting Started",
    //       icon: "sparkles",
    //       items: ["Project-V-Intro"],
    //     },
    //     {
    //       type: "category",
    //       label: "Useful Links",
    //       collapsible: false,
    //       icon: "link",
    //       items: [
    //         {
    //           type: "link",
    //           icon: "book",
    //           label: "Zudoku Docs",
    //           to: "https://zudoku.dev/docs/",
    //         },
    //       ],
    //     },
    //   ],
    // },
    {
      type: "link",
      label: "API Catalog",
      icon: "square-library",
      to: "catalog",
    },
  ],
  redirects: [
    // Redirect the root to your main intro page
    { from: "/", to: "/catalog" },
  ],
  apis: [
    // Define the two separate APIs with their own paths and sidebar labels

    {
      type: "file",
      input: "./apis/adminAuth/adminAuth.openapi.yaml",
      path: "/catalog/admin-auth", // Dedicated path for admin docs
      categories: [
        {
          label: "Authentication",
          tags: ["Admin Authentication"],
        },
      ],
    },
    {
      type: "file",
      input: "./apis/userAuth/userAuth.openapi.yaml",
      path: "/catalog/user-auth", // Dedicated path for user docs
      categories: [
        {
          label: "Authentication",
          tags: ["User Authentication"],
        },
      ],
    },
    {
      type: "file",
      input: "./apis/auth/auth.openapi.yaml",
      path: "/catalog/auth",
      categories: [
        {
          label: "Authentication",
          tags: ["Actor Authentication"],
        },
      ],
    },
    {
      type: "file",
      input: "./apis/admin/admin.openapi.yaml",
      path: "/catalog/admin", // Dedicated path for admin docs
      categories: [
        {
          label: "Management",
          tags: ["Admin Management"],
        },
      ],
    },
    {
      type: "file",
      input: "./apis/user/user.openapi.yaml",
      path: "/catalog/user", // Dedicated path for user docs
      categories: [
        {
          label: "Management",
          tags: ["User Management"],
        },
      ],
    },
    {
      type: "file",
      input: "./apis/identityVerification/identityVerification.openapi.yaml",
      path: "/catalog/identityVerification",
      categories: [
        {
          label: "Management",
          tags: ["identityVerification Management"],
        },
      ],
    },
    {
      type: "file",
      input: "./apis/tag/tag.openapi.yaml",
      path: "/catalog/tag", // Dedicated path for user docs
      categories: [
        {
          label: "Management",
          tags: ["Tag Management"],
        },
      ],
    },
    {
      type: "file",
      input: "./apis/station/station.openapi.yaml",
      path: "/catalog/station", // Dedicated path for user docs
      categories: [
        {
          label: "Management",
          tags: ["Station Management"],
        },
      ],
    },
    {
      type: "file",
      input: "./apis/settings/settings.openapi.yaml",
      path: "/catalog/settings", // Dedicated path for settings docs
      categories: [
        {
          label: "Management",
          tags: ["Settings Management"],
        },
      ],
    },
    {
      type: "file",
      input: "./apis/ticket/ticket.openapi.yaml",
      path: "/catalog/ticket", // Dedicated path for ticket docs
      categories: [
        {
          label: "Management",
          tags: ["Ticket Management"],
        },
      ],
    },
    {
      type: "file",
      input: "./apis/wallet/wallet.openapi.yaml",
      path: "/catalog/wallet", // Dedicated path for wallet docs
      categories: [
        {
          label: "Management",
          tags: ["Wallet Management"],
        },
      ],
    },
    {
      type: "file",
      input: "./apis/taskStructure/taskStructure.openapi.yaml",
      path: "/catalog/task-structure", // Dedicated path for task structure docs
      categories: [
        {
          label: "Management",
          tags: ["Task Structure Management"],
        },
      ],
    },
    {
      type: "file",
      input: "./apis/task/task.openapi.yaml",
      path: "/catalog/task", // Dedicated path for task docs
      categories: [
        {
          label: "Management",
          tags: ["Task Management"],
        },
      ],
    },
    {
      type: "file",
      input: "./apis/transaction/transaction.openapi.yaml",
      path: "/catalog/transaction", // Dedicated path for transaction docs
      categories: [
        {
          label: "Management",
          tags: ["Transaction Management"],
        },
      ],
    },
    {
      type: "file",
      input: "./apis/lock/lock.openapi.yaml",
      path: "/catalog/lock", // Dedicated path for lock docs
      categories: [
        {
          label: "Management",
          tags: ["Lock Management"],
        },
      ],
    },
    {
      type: "file",
      input: "./apis/pricePlan/pricePlan.openapi.yaml",
      path: "/catalog/price-plan", // Dedicated path for price plan docs
      categories: [
        {
          label: "Management",
          tags: ["Price Plan Management"],
        },
      ],
    },
    {
      type: "file",
      input: "./apis/subscription/subscription.openapi.yaml",
      path: "/catalog/subscription", // Dedicated path for subscription docs
      categories: [
        {
          label: "Management",
          tags: ["Subscription Management"],
        },
      ],
    },
    {
      type: "file",
      input: "./apis/vehicle/vehicle.openapi.yaml",
      path: "/catalog/vehicle", // Dedicated path for vehicle docs
      categories: [
        {
          label: "Management",
          tags: ["Vehicle Management"],
        },
      ],
    },
    {
      type: "file",
      input: "./apis/activityLog/activityLog.openapi.yaml",
      path: "/catalog/activity-log", // Dedicated path for activity log docs
      categories: [
        {
          label: "Management",
          tags: ["Activity Log Management"],
        },
      ],
    },
    {
      type: "file",
      input: "./apis/response/response.openapi.yaml",
      path: "/catalog/response", // Dedicated path for response docs
      categories: [
        {
          label: "Management",
          tags: ["Response Management"],
        },
      ],
    },
    {
      type: "file",
      input: "./apis/suspension/suspension.openapi.yaml",
      path: "/catalog/suspension", // Dedicated path for suspension docs
      categories: [
        {
          label: "Management",
          tags: ["Suspension Management"],
        },
      ],
    },
    {
      type: "file",
      input: "./apis/ride/ride.openapi.yaml",
      path: "/catalog/ride", // Dedicated path for ride docs
      categories: [
        {
          label: "Management",
          tags: ["Ride Management"],
        },
      ],
    },
    {
      type: "file",
      input: "./apis/role/role.openapi.yaml",
      path: "/catalog/role",
      categories: [
        {
          label: "Management",
          tags: ["Role Management"],
        },
      ],
    },
  ],
};

export default config;
